import React from 'react';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { Heading } from '@/components/ui/heading';
import { SectionCard } from '@/components/ui/section-card';
import WeSki from './WeSkiWidget';

const GlobalTemplateWeSkiWidget = () => {
  const { t } = useOTSTranslation('common');

  if (process.env.NEXT_PUBLIC_LANG !== 'en-GB') return null;

  return (
    <section className="mt-10">
      <Heading
        level={2}
        className="mb-4"
      >
        {t('tripWidget.planYourTrip')}
      </Heading>
      <SectionCard as="div" padding="sm" className="md:p-6">
        <WeSki destinationId="flexible" />
      </SectionCard>
    </section>
  );
};

export default GlobalTemplateWeSkiWidget;
